<template>
    <CodiceFeanorView tool-module="hashLookup" />
</template>

<script setup>
import CodiceFeanorView from "../CodiceFeanorView.vue";
</script>
